import { render, staticRenderFns } from "./widgetIndex.vue?vue&type=template&id=00311517"
import script from "./widgetIndex.vue?vue&type=script&lang=js"
export * from "./widgetIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports